import { render } from "./NewButton.vue?vue&type=template&id=74bf188c&scoped=true"
import script from "./NewButton.vue?vue&type=script&lang=js"
export * from "./NewButton.vue?vue&type=script&lang=js"

import "./NewButton.vue?vue&type=style&index=0&id=74bf188c&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bf188c"]])

export default __exports__